export default __webpack_public_path__ + "static/media/FISH.f19e5927.png";